// import { useState } from "react";
import {
  useFieldArray,
  UseFieldArrayReturn,
  useFormContext,
} from "react-hook-form";

import { IAppForm } from "../lib/interfaces/models";
import { SubjectForm } from "./SubjectForm";
import { Divider } from "@mui/material";

interface ISelect {
  nr: number
  name: string
}
export interface IApiSubject {
  nr: number
  name: string
  label: string
}
export interface IApiSubjects {
  options: IApiSubject[]
  teacherOptions: IApiSubject[]
  placeOptions: ISelect[]
  gradeOptions: ISelect[]
  ratioOptions: ISelect[]
  subjectMax: number
  teacherFlag: number | 0
}



export const Subjects = (props: IApiSubjects) => {
  // const [showAddButton, setShowAddButton] = useState(true)

  const options = props.options.map((option) => {
    return ({ value: option.nr, title: option.name })
  })
  const teacherOptions = props.teacherOptions.map(option => {
    return ({ value: option.nr, title: option.name })
  })
  const placeOptions = props.placeOptions.map(option => {
    return ({ value: option.nr, title: option.name })
  })
  const gradeOptions = props.gradeOptions.map(option => {
    return ({ value: option.nr, title: option.name })
  })
  const ratioOptions = props.ratioOptions.map(option => {
    return ({ value: option.nr, title: option.name })
  })

  const form = useFormContext<IAppForm>();

  const subjectsField: UseFieldArrayReturn<IAppForm> =
    useFieldArray<IAppForm>({
      control: form.control,
      name: "subjects",
    });

  const addNewSubject = () => {
    if (subjectsField.fields.length < (props.subjectMax)) {

      subjectsField.append(
        {
          name: "subject",
          id: 0
        }
      )
    }
  }

  const removeSubject = (index: number) => {
    if (subjectsField.fields.length === 1) {
      return
    }
    subjectsField.remove(index)
  }

  if (subjectsField.fields.length === 0) {
    addNewSubject()
  }

  return (
    <>
      {subjectsField.fields.map((field, index) => (
        <SubjectForm
          key={field.id}
          index={index}
          label="Námsgrein"
          name="subject"
          options={options}
          teacherOptions={teacherOptions}
          teacherFlag={props.teacherFlag}
          placeOptions={placeOptions}
          gradeOptions={gradeOptions}
          ratioOptions={ratioOptions}
          onRemove={removeSubject}
          disableRemoveButton={subjectsField.fields.length === 1 ? true : false}
        />
      ))}
      {/* {subjectsField.fields.length < (props.subjectMax) && <Button type="button" variant="outlined" sx={{ m: 1 }} onClick={addNewSubject}>
        {
          // subjectsField.fields.length === 0 ? 'Námsgrein' : 'Bæta við Námsgrein'
          `Námsgrein - ${subjectsField.fields.length + 1}. val`
        }
      </Button>} */}

      <Divider sx={{ mt: 1 }} />
    </>
  )


}